import angular from 'angular'
import { inputApprove } from 'redevConfig'
const list = (inputApprove && inputApprove.list) || ''

const inputApproveList = list ? require(`redevelopment/statistics/inputApprove/${list.templateName}`) : require('./view/inputApprove.html')
const inputApproveListCtrl = list ? require(`redevelopment/statistics/inputApprove/${list.controllerName}`) : require('./inputApproveCtrl.js')
export default angular
    .module('statistics.chartAnalysis.inputApprove', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.chartAnalysis.inputApprove', {
            url: '/inputApprove',
            abstract: true,
            template: '<div ui-view></div>',
            title: '进项认证',
            default: 'statistics.chartAnalysis.inputApprove.list',
        })
        $stateProvider.state('statistics.chartAnalysis.inputApprove.list', {
            url: '/list',
            template: inputApproveList,
            controller: 'inputApproveListCtrl',
        })
    }])
    .controller('inputApproveListCtrl', inputApproveListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/inputApprove/index.js